export function createUrlSearchParams(params) {
    const searchParams = new URLSearchParams();

    for (const key in params) {
        const value = params[key];
        if (Boolean(value)) {
            searchParams.append(key, value);
        }
    }

    return searchParams?.toString();
}
